import {PayStatus} from "@/app/(pay)/types";

export default class PayUtil {

    static getPayChannelName(channel:number){
        // switch(channel){
        //     case PAY.PayChannel.ApplePay:
        //         return channel;
        // }
        return `pay_${channel}.webp`;
    }

    static getPayStatusName(status:PayStatus):string{
        switch (status) {
            case PayStatus.WAITING:
                return "WAITING";
            case PayStatus.CREATE_FAIL:
                return "CREATE_FAIL";
            case PayStatus.FAIL:
                return "FAIL";
            case PayStatus.SUCCESS:
                return "SUCCESS";
            case PayStatus.CANCEL:
                return "CANCEL";
            case PayStatus.TIMEOUT:
                return "TIMEOUT";
            default:
                // return `name_${status}`;
                return `No payment result found.`;
        }
    }



}